


















































































































































































































import Vue, { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import {
  CabinetReferenceConfigurationModel,
  EditMode,
  ValueType,
  SearchReferenceConfigurationModel,
  StoreReferenceConfigurationModel,
  ListConfigurationModel,
  CabinetConfigurationSettingNameConstants,
  CabinetConfigurationSettingModel,
  CabinetConfigurationSettingValueModel,
  InputType,
  CabinetReferenceType,
  ListModel,
  ListHeaderModel,
  CabinetConfigurationLevel,
  CabinetConfigurationModel,
  StoreConstants
} from '@/types';
import MStoreAccordion from '@/components/shared/MStoreAccordion.vue';
import MStoreFormInput from '@/components/shared/MStoreFormInput.vue';
import MStoreFormSelect from '@/components/shared/MStoreFormSelect.vue';
import MStoreForm from '@/components/shared/MStoreForm.vue';
import MStoreFormSelectTable from '@/components/shared/MStoreFormSelectTable.vue';
import MStoreFormCheckbox from '@/components/shared/MStoreFormCheckbox.vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import { ObjectUtils } from '@/utils/objectUtils';
import { CabinetConfigurationHelper, confirmationHelper, FormFieldValidation } from '@/mixins';
import { ValidationModel } from '@/types/models/validation';
import { ArrayUtils } from '@/utils';

export default Vue.extend({
  name: 'ReferenceConfiguration',
  mixins: [FormFieldValidation, CabinetConfigurationHelper, confirmationHelper],
  data() {
    return {
      show: false,
      cabinetReferenceConfigurationClone: {} as CabinetReferenceConfigurationModel,
      searchReferenceConfigurationClone: {} as SearchReferenceConfigurationModel,
      storeReferenceConfigurationClone: {} as StoreReferenceConfigurationModel
    };
  },
  props: {
    showReferenceConfiguration: {
      type: Boolean
    },
    editMode: {
      type: Number as PropType<EditMode>,
      required: true
    },
    referenceType: {
      type: Number as PropType<CabinetReferenceType>,
      required: true
    },
    cabinetConfiguration: {
      type: Object as () => CabinetConfigurationModel,
      required: true
    },
    cabinetReferenceConfiguration: {
      type: Object as () => CabinetReferenceConfigurationModel,
      required: true
    },
    storeReferenceConfiguration: {
      type: Object as () => StoreReferenceConfigurationModel,
      required: true
    },
    searchReferenceConfiguration: {
      type: Object as () => SearchReferenceConfigurationModel,
      required: true
    },
    configurationLevel: {
      type: Number as PropType<CabinetConfigurationLevel>,
      required: true
    },
    defaultStoreReferenceConfiguration: {
      type: Object as () => StoreReferenceConfigurationModel
    },
    formName: {
      type: String,
      default: 'referenceConfigurationForm'
    },
    isParentLoading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions(StoreConstants.CabinetConfiguration.ModuleName, [StoreConstants.CabinetConfiguration.Actions.GetCabinetConfigurationSettingsWithErrorPage]),
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    cloneReferenceConfiguration(this: any) {
      this.cabinetReferenceConfigurationClone = ObjectUtils.deepCloneObject(this.cabinetReferenceConfiguration);
      this.storeReferenceConfigurationClone = ObjectUtils.deepCloneObject(this.storeReferenceConfiguration);
      this.searchReferenceConfigurationClone = ObjectUtils.deepCloneObject(this.searchReferenceConfiguration);
    },
    async onCancelClickedAsync(this: any, noChangesMade: boolean) {
      if (!noChangesMade) {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true);
        if (hasUnsavedChangesToKeep) {
          return;
        }
      }
      this.$emit('on-cancel-reference-configuration');
    },
    onVisibleChanged(this: any) {
      if (!this.storeReferenceConfigurationClone.visible) {
        this.storeReferenceConfigurationClone.required = false;
      }
    },
    onRequiredChanged(this: any) {
      if (this.storeReferenceConfigurationClone.required) {
        this.storeReferenceConfigurationClone.visible = true;
      }
    },
    async onSubmitAsync(this: any) {
      this.resetFormValidation();
      try {
        const isValid = await this.$validator.validate();
        if (!isValid || !this.referenceDescriptionIsValid()) {
          return;
        }
      } catch (error) {
        this.$log(error);
        return;
      }

      if (
        this.hasMultiValueChangedForExistingReference &&
        !(await this.showConfirmationModalAsync(
          this.$bvModal,
          'Changing a reference between single and multi-value will cause the existing reference values to be hidden. Are you sure you want to continue?'
        ))
      ) {
        return;
      }

      this.$emit('on-ok-reference-configuration', this.cabinetReferenceConfigurationClone, this.storeReferenceConfigurationClone, this.searchReferenceConfigurationClone);
    },
    referenceDescriptionIsValid(this: any) {
      let isValid = true;
      if (this.isInAddMode) {
        isValid = !this.referencesExistWithSameDescription(
          this.cabinetConfiguration.cabinetReferences,
          this.cabinetReferenceConfigurationClone.description,
          this.cabinetReferenceConfiguration.documentTypeId,
          this.referenceType
        );
      }

      if (this.isInEditMode) {
        const currentReferenceIndex = this.getCabinetReferenceIndex(this.cabinetConfiguration, this.cabinetReferenceConfigurationClone, this.cabinetReferenceConfigurationClone.documentTypeId);
        const remainingCabinetReferences = ArrayUtils.immutableSplice(this.cabinetConfiguration.cabinetReferences, currentReferenceIndex, 1);
        isValid = !this.referencesExistWithSameDescription(
          remainingCabinetReferences,
          this.cabinetReferenceConfigurationClone.description,
          this.cabinetReferenceConfiguration.documentTypeId,
          this.referenceType
        );
      }
      if (!isValid) {
        this.$refs.referenceName.$refs.ValidationProvider.applyResult({
          errors: ['Name must be unique, existing cabinet or document type reference has the same name'],
          valid: false,
          failedRules: {}
        });
      }
      return isValid;
    },
    onStoreInputTypeChanged(this: any) {
      if (this.storeReferenceConfigurationClone.inputType === InputType.DropdownAndSearch) {
        return;
      }
      this.storeReferenceConfigurationClone.listId = null;
      this.storeReferenceConfigurationClone.mustExistInList = null;
    },
    onSearchInputTypeChanged(this: any) {
      if (this.searchReferenceConfigurationClone.inputType === InputType.DropdownAndSearch) {
        return;
      }
      this.searchReferenceConfigurationClone.listId = null;
    },
    onStoreListChange(this: any, value: any) {
      this.storeReferenceConfigurationClone.listId = value;
    },
    onSearchListChange(this: any, value: any) {
      this.searchReferenceConfigurationClone.listId = value;
    },
    onUseDefaultsChanged(this: any) {
      if (this.storeReferenceConfigurationClone.useDefaults && !ObjectUtils.isNullOrEmpty(this.defaultStoreReferenceConfiguration)) {
        this.storeReferenceConfigurationClone.visible = this.defaultStoreReferenceConfiguration.visible;
        this.storeReferenceConfigurationClone.required = this.defaultStoreReferenceConfiguration.required;
        this.storeReferenceConfigurationClone.mustExistInList = this.defaultStoreReferenceConfiguration.mustExistInList;
        this.storeReferenceConfigurationClone.fixedLength = this.defaultStoreReferenceConfiguration.fixedLength;
        this.storeReferenceConfigurationClone.requiredLength = this.defaultStoreReferenceConfiguration.requiredLength;
        this.storeReferenceConfigurationClone.inputType = this.defaultStoreReferenceConfiguration.inputType;
        this.storeReferenceConfigurationClone.upperCase = this.defaultStoreReferenceConfiguration.upperCase;
        this.storeReferenceConfigurationClone.validationType = this.defaultStoreReferenceConfiguration.validationType;
        this.storeReferenceConfigurationClone.listId = this.defaultStoreReferenceConfiguration.listId;
      }
    },
    onDirtyForm(this: any, isDirty: boolean) {
      if (this.isApplicationDirty) {
        return;
      }
      if (isDirty) {
        this.setApplicationDirty(isDirty);
      }
    }
  },
  computed: {
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty']),
    ...mapGetters(StoreConstants.CabinetConfiguration.ModuleName, [
      StoreConstants.CabinetConfiguration.Getters.CabinetConfigurationSettings,
      StoreConstants.CabinetConfiguration.Getters.IsConfigurationLoading,
      StoreConstants.CabinetConfiguration.Getters.ReferenceStoringConfigurationSetting,
      StoreConstants.CabinetConfiguration.Getters.ReferenceSearchingConfigurationSetting,
      StoreConstants.CabinetConfiguration.Getters.ListConfigurations
    ]),
    containerClass(this: any) {
      return `${this.isConfigurationLoading ? 'opacity-65' : ''} reference-configuration-body`;
    },
    referenceTitle(this: any) {
      if (this.editMode === EditMode.Add) {
        return 'Add a Reference';
      }
      return `${this.editMode === EditMode.View ? 'View' : 'Edit'} ${this.cabinetReferenceConfiguration?.description} Reference`;
    },
    storeInputTypeIsList(this: any) {
      return this.storeReferenceConfigurationClone.inputType === InputType.DropdownAndSearch;
    },
    searchInputTypeIsList(this: any) {
      return this.searchReferenceConfigurationClone.inputType === InputType.DropdownAndSearch;
    },
    referenceDescriptionEmpty(this: any) {
      return !this.cabinetReferenceConfigurationClone.description;
    },
    maximumlengthEmpty(this: any) {
      return ObjectUtils.isNaN(this.cabinetReferenceConfigurationClone.maximumLength);
    },
    storeListEmpty(this: any) {
      return this.storeInputTypeIsList && ObjectUtils.isNaN(this.storeReferenceConfigurationClone.listId);
    },
    searchListEmpty(this: any) {
      return this.searchInputTypeIsList && ObjectUtils.isNaN(this.searchReferenceConfigurationClone.listId);
    },
    formInvalid(this: any) {
      return this.referenceDescriptionEmpty || this.maximumlengthEmpty || this.storeListEmpty || this.searchListEmpty;
    },
    storeListValidation(this: any) {
      return {
        required: this.storeReferenceConfigurationClone.inputType === InputType.DropdownAndSearch
      } as ValidationModel;
    },
    searchListValidation(this: any) {
      return {
        required: this.searchReferenceConfigurationClone.inputType === InputType.DropdownAndSearch
      } as ValidationModel;
    },
    isInAddMode(this: any) {
      return this.editMode === EditMode.Add;
    },
    isInEditMode(this: any) {
      return this.editMode === EditMode.Edit;
    },
    isInViewMode(this: any) {
      return this.editMode === EditMode.View;
    },
    listModel(this: any) {
      return {
        id: -1,
        key: 'AllLists',
        text: 'AllLists',
        headers: [{ id: '0', data: 'id', title: 'Id' } as ListHeaderModel, { id: '1', data: 'description', title: 'Description' } as ListHeaderModel] as ListHeaderModel[],
        list: this.lists || [],
        totalRow: this.lists.length
      } as ListModel;
    },
    isCommonReferenceType(this: any) {
      return this.referenceType === CabinetReferenceType.Common;
    },
    documentTypeCommonReference(this: any) {
      return this.isCommonReferenceType && this.configurationLevel === CabinetConfigurationLevel.DocumentType;
    },
    storeFieldDisabled(this: any) {
      return this.isInViewMode || (this.documentTypeCommonReference && Boolean(this.storeReferenceConfigurationClone?.useDefaults));
    },
    commonFieldDisabled(this: any) {
      return this.isInViewMode || this.documentTypeCommonReference;
    },
    storingInputTypes(this: any): CabinetConfigurationSettingValueModel[] {
      return this.referenceStoringConfigurationSetting(CabinetConfigurationSettingNameConstants.InputType).settingValues;
    },
    searchingInputTypes(this: any): CabinetConfigurationSettingValueModel[] {
      return this.referenceSearchingConfigurationSetting(CabinetConfigurationSettingNameConstants.InputType).settingValues;
    },
    storingValidationTypes(this: any): CabinetConfigurationSettingValueModel[] {
      return this.referenceStoringConfigurationSetting(CabinetConfigurationSettingNameConstants.ValidationType).settingValues;
    },
    searchingValidationTypes(this: any): CabinetConfigurationSettingValueModel[] {
      return this.referenceSearchingConfigurationSetting(CabinetConfigurationSettingNameConstants.ValidationType).settingValues;
    },
    lists(this: any): ListConfigurationModel[] {
      return this.listConfigurations;
    },
    maximumLength: {
      get(this: any) {
        return (this.cabinetReferenceConfigurationClone as CabinetReferenceConfigurationModel).maximumLength.toString();
      },
      set(this: any, value) {
        Vue.set(this.cabinetReferenceConfigurationClone, 'maximumLength', Number(value));
      }
    },
    hasMultiValueChangedForExistingReference(this: any): boolean {
      return (
        this.editMode === EditMode.Edit && !this.cabinetReferenceConfigurationClone.isNew && this.cabinetReferenceConfigurationClone.isMultiValue !== this.cabinetReferenceConfiguration.isMultiValue
      );
    }
  },
  watch: {
    showReferenceConfiguration(this: any) {
      this.show = this.showReferenceConfiguration;
      if (this.show) {
        this.cloneReferenceConfiguration();
      }
    }
  },
  async mounted(this: any) {
    this.show = this.showReferenceConfiguration;
    this.cloneReferenceConfiguration();
  },
  created(this: any) {
    this.maxLengthValidation = {
      required: true,
      valueType: ValueType.Integer,
      minValue: 1,
      maxValue: 255
    } as ValidationModel;
  },
  components: {
    MStoreAccordion,
    MStoreForm,
    MStoreFormInput,
    MStoreFormSelect,
    LoadingSpinner,
    MStoreFormSelectTable,
    MStoreFormCheckbox
  }
});
